import script from "./CardObjectivesHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CardObjectivesHeader.vue?vue&type=script&setup=true&lang=js"

import "./CardObjectivesHeader.vue?vue&type=style&index=0&id=570139b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570139b0"]])

export default __exports__